/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-14 14:48:20
 * @LastEditTime: 2019-08-14 15:01:57
 * @LastEditors: Please set LastEditors
 */
import axios, { AxiosRequestConfig, AxiosError } from "axios";
import { Loading } from "element-ui";
import { PltRes } from "@szgc/plt-core-v2";
import loadingController from "./loading_controller";

// let loading: any = null;
const minTime = 50 // 请求小于此时间则不显示loading效果
const delayTime = 50 // 串行的相邻请求小于该时间则延迟loading效果结束
let requestNum = 0

const request: any = axios.create({
  baseURL: "/",
  timeout: 0
});

request.interceptors.request.use((config: any) => {
  // loading = Loading.service({
  //   fullscreen: true,
  //   lock: true,
  //   text: "加载中..."
  // });
  return config;
});

request.interceptors.response.use(
  (resp: any) => {
    // loading && loading.close();
    if (resp.status !== 200) {
      return Promise.reject(resp.data);
    }
    return resp.data;
  },
  (error: AxiosError) => {
    // loading && loading.close();
    loadingController.hide_loading();
    return Promise.reject(error);
  }
);

export default function<T = Record<string,any>>(option:AxiosRequestConfig):Promise<PltRes<T>> {
  requestNum++
  const timeout = setTimeout(() => {
    loadingController.show_loading();
  }, minTime)
  return request(option)
    .then((data: PltRes<T>) => {
      requestNum--
      clearTimeout(timeout)
      setTimeout(() => {
        // 延迟loading的效果,防止串行的请求白光效果
        if (requestNum <= 0) {
          loadingController.hide_loading();
        }
      }, delayTime)
      return data
    })
    .catch((error: PltRes<T> | AxiosError) => {
      requestNum--
      clearTimeout(timeout)
      setTimeout(() => {
        // 延迟loading的效果,防止串行的请求白光效果
        if (requestNum <= 0) {
          loadingController.hide_loading();
        }
      }, delayTime)
      return Promise.reject(error)
    })
}
